import { Course } from "@interfaces/course/course"
import React, { useEffect, useState } from "react"
import { FlexBox, LoadingBox } from "@components/wrapper"
import { NO_DATA } from "@constants/const/pictures"
import clsx from "clsx"
import { ClassCard } from "@components/card"
import Image from "next/image"
import { PaginationData } from "@interfaces/misc"
import { chunk } from "@lib/functions"
import CourseListServices from "@lib/api/services/course-list.services"

interface ClassColumnProps {
  screenWidth: number
  classList: PaginationData<Course>
}

export const ClassColumn = ({ screenWidth, classList }: ClassColumnProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const [courses, setCourses] = useState<Course[]>([])
  const [mobileCourses, setMobileCourses] = useState<Course[][]>([])
  const courseList = new CourseListServices()

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true)
        const resCourseList = await courseList.getCourseList({
          limit: 20,
          page: 1,
        })

        if (resCourseList.isSuccess) {
          const dataCourse = resCourseList.getValue().data
          setCourses(dataCourse)
          const chunked = chunk(dataCourse, 3)
          setMobileCourses(chunked)
        }

        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
      }
    }

    getData()
  }, [])

  if (isLoading) {
    return <LoadingBox height="h-[50vh]" />
  }

  if (!courses.length) {
    return (
      <FlexBox
        justify="center"
        align="center"
        direction="col"
        className={clsx("sm:w-full sm:py-20", "sm-only:px-4 py-10")}
      >
        <Image src={NO_DATA} alt="" className="sm:w-1/3 mb-10 w-3/4" width={500} height={500} />
        <div className=" font-semibold mb-2.5">Maaf, Kelas Belum Tersedia Saat Ini</div>
        <div className={clsx("font-semibold text-grey-97", "sm-only:text-sm sm-only:text-center")}>
          Nantikan video course terbaik yang dapat segera kamu ikuti, hanya di Harisenin.com
        </div>
      </FlexBox>
    )
  }

  if (screenWidth > 576) {
    return (
      <div className="grid grid-cols-3 gap-6 w-full">
        {classList.data.map((value, index) => (
          <ClassCard data={value} key={index} className=" w-full mb-[60px]" />
        ))}
      </div>
    )
  } else {
    return (
      <div className="grid grid-cols-2 gap-4 w-full mt-4">
        {classList.data.map((value, index) => (
          <ClassCard data={value} key={index} className=" w-full mb-[16px]" />
        ))}
      </div>
    )
  }
}
